import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin } from 'rxjs';
import { DadosPortadorDeficienciaServiceAba6 } from '../../service/dados-deficiencia-aba6/dados-deficiencia-aba6.service';

@Component({
  selector: 'app-recadastramento-aba6',
  templateUrl: './recadastramento-aba6.component.html',
  styleUrls: ['./recadastramento-aba6.component.sass']
})
export class RecadastramentoAba6Component implements OnInit {
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup;
  user: DadosPessoaisAba1Response = null;

  ehPortadorDeficiencia: boolean;

  existDiffDataChegadaBrasil: boolean = false;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private dadosPortadorDeficienciaServiceAba6: DadosPortadorDeficienciaServiceAba6,
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.form = this.formBuilder.group({
      ehPortadorDeficiencia: [''],
      deficienciaFisica: [{ value: false, disabled: true }],
      deficienciaVisual: [{ value: false, disabled: true }],
      deficienciaAuditiva: [{ value: false, disabled: true }],
      deficienciaMental: [{ value: false, disabled: true }],
      deficienciaIntelectual: [{ value: false, disabled: true }],
      deficienciaEspectroAutista: [{ value: false, disabled: true }]
    });
  }
  checkCheckboxSelection(formGroup: FormGroup) {
    const ehPortadorDeficiencia = formGroup.get('ehPortadorDeficiencia')?.value;
    const checkboxes = [
      'deficienciaFisica',
      'deficienciaVisual',
      'deficienciaAuditiva',
      'deficienciaMental',
      'deficienciaIntelectual',
      'deficienciaEspectroAutista'
    ];

    if (ehPortadorDeficiencia === 'S') {
      const atLeastOneChecked = checkboxes.some(checkbox => formGroup.get(checkbox)?.value);
      return atLeastOneChecked ? null : { atLeastOneCheckboxRequired: true };
    }

    return null;
  }
  ngOnInit(): void {
    this.processarPortadorDeficiencia();
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  private processarPortadorDeficiencia(): void {

    const deficiencia$: Observable<any> = this.getDeficiencia();

    forkJoin([deficiencia$])
      .pipe()
      .subscribe(
        ([deficiencia]) => {
          this.atualizarFormulario(deficiencia);
        },
        (error) => {
          //this.mostrarMensagem('Ocorreu um erro ao carregar os dados. Por favor, tente novamente.');
        }
      );
  }

  private getDeficiencia(): Observable<any> {
    return this.dadosPortadorDeficienciaServiceAba6.getDadosDeficiencia();
  }

  atualizarFormulario(deficiencia) {
    this.form.patchValue({
      ehPortadorDeficiencia: deficiencia.ehPortadorDeficiencia,
      deficienciaFisica: deficiencia.deficienciaFisica,
      deficienciaVisual: deficiencia.deficienciaVisual,
      deficienciaAuditiva: deficiencia.deficienciaAuditiva,
      deficienciaMental: deficiencia.deficienciaMental,
      deficienciaIntelectual: deficiencia.deficienciaIntelectual,
      deficienciaEspectroAutista: deficiencia.deficienciaEspectroAutista,
    });
  }

 /* onChangeEhPortadorDeficiencia() {
    this.form.get('ehPortadorDeficiencia').valueChanges.subscribe(value => {
      if (value === 'N') {
        // Limpar os valores dos checkboxes
        this.form.get('deficienciaFisica').setValue(false);
        this.form.get('deficienciaVisual').setValue(false);
        this.form.get('deficienciaAuditiva').setValue(false);
        this.form.get('deficienciaMental').setValue(false);
        this.form.get('deficienciaIntelectual').setValue(false);
      }
    });
  }*/

  atualizarDeficiencia() {
    if (this.form.valid) {
      // Lógica para enviar os dados do formulário
      this.dadosSalvos.emit();
      /*this.dadosPortadorDeficienciaServiceAba6.atualizarDadosDeficiencia(this.form.value).subscribe(
        (response) => {
          this.toasterService.success('Dados atualizados com sucesso');
          this.dadosSalvos.emit();
        },
        (error) => {
          console.error('Erro ao atualizar os dados', error);
        }
      );*/
    } 
    else if (this.form.get('ehPortadorDeficiencia').value == '' || this.form.get('ehPortadorDeficiencia').value == null){
      this.toasterService.warning('Atenção: É necessário selecionar o campo É pessoa com deficiência');
    }
    else{
      this.toasterService.warning('Atenção: É necessário selecionar ao menos um tipo de deficiência');
    }

  }
  
  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
